const PAGE_SIZE_OPTIONS = [30, 50, 100];

export const TablePagination = ({ currentPage, pageSize, setCurrentPage, setPageSize, totalItems, testIdPrefix }) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  if (!totalItems) {
    return null;
  }

  const startRow = (currentPage - 1) * pageSize + 1;
  const endRow = Math.min(currentPage * pageSize, totalItems);

  return (
    <div className="flex flex-col gap-3 border-t border-zinc-200 px-5 py-4 md:flex-row md:items-center md:justify-between" data-testid={`${testIdPrefix}-pagination`}>
      <p className="text-sm text-zinc-500" data-testid={`${testIdPrefix}-pagination-summary`}>
        Showing {startRow}-{endRow} of {totalItems}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <label className="flex items-center gap-2 text-sm text-zinc-600" data-testid={`${testIdPrefix}-pagination-page-size-wrap`}>
          <span>Items per page</span>
          <select className="rounded-2xl border border-zinc-200 bg-white px-3 py-2 text-sm font-semibold text-zinc-700" data-testid={`${testIdPrefix}-pagination-page-size`} onChange={(event) => setPageSize(Number(event.target.value))} value={pageSize}>
            {PAGE_SIZE_OPTIONS.map((option) => <option key={`${testIdPrefix}-page-size-${option}`} value={option}>{option}</option>)}
          </select>
        </label>
        <button className="rounded-2xl border border-zinc-200 px-4 py-2 text-sm font-semibold text-zinc-700 disabled:opacity-50" data-testid={`${testIdPrefix}-pagination-prev`} disabled={currentPage === 1} onClick={() => setCurrentPage((page) => Math.max(1, page - 1))} type="button">Previous</button>
        <span className="text-sm font-semibold text-zinc-700" data-testid={`${testIdPrefix}-pagination-page`}>Page {currentPage} of {totalPages}</span>
        <button className="rounded-2xl border border-zinc-200 px-4 py-2 text-sm font-semibold text-zinc-700 disabled:opacity-50" data-testid={`${testIdPrefix}-pagination-next`} disabled={currentPage === totalPages} onClick={() => setCurrentPage((page) => Math.min(totalPages, page + 1))} type="button">Next</button>
      </div>
    </div>
  );
};